// third-party
import { configureStore } from "@reduxjs/toolkit";
import {
  useDispatch as useAppDispatch,
  useSelector as useAppSelector,
  TypedUseSelectorHook,
} from "react-redux";
import { persistStore } from "redux-persist";

// project imports
import rootReducer from "./reducer";
import authApi from "features/authentication/services/auth";
import employeesApi from "features/employee/services/employee";
import debtorsApi from "features/debtor/services/debtor";
import applicationApi from "features/application/services/application";
import dictionaryApi from "shared/services/dictionary";
import signatureApi from "features/signature/services/signature";
import contractsApi from "shared/services/contract";
import noticesApi from "features/notice/services/notice";
import attachmentsApi from "features/notice/services/attachments";
import disbursementApi from "features/disbursement/services/disbursements";
import reportApi from "features/compraPkb/services/report";
import organizationsApi from "features/organization/services/organization";
import leadsApi from "features/lead/services/lead";
import additionalContractApi from "features/additionalContract/services/additionalContract";
import analyticalTreeMapApi from "features/analyticalTreeMap/services/analyticalTreeMap";
import analyticalReportApi from "features/analyticalReport/services/analyticalReport";
import factorsApi from "shared/services/factor";
import templateApi from "features/template/services/template";
import notificationApi from "shared/services/notification";


const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }).concat(
      authApi.middleware,
      employeesApi.middleware,
      debtorsApi.middleware,
      applicationApi.middleware,
      dictionaryApi.middleware,
      signatureApi.middleware,
      contractsApi.middleware,
      noticesApi.middleware,
      attachmentsApi.middleware,
      disbursementApi.middleware,
      reportApi.middleware,
      organizationsApi.middleware,
      leadsApi.middleware,
      additionalContractApi.middleware,
      analyticalTreeMapApi.middleware,
      analyticalReportApi.middleware,
      factorsApi.middleware,
      templateApi.middleware,
      notificationApi.middleware
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

const { dispatch } = store;
const persistor = persistStore(store);

const useDispatch = () => useAppDispatch<AppDispatch>();
const useSelector: TypedUseSelectorHook<RootState> = useAppSelector;

export { store, persistor, dispatch, useSelector, useDispatch };
